import Vue from 'vue';

if (window.hwerrVue) {
  Vue.config.errorHandler = window.hwerrVue;
}
import { initBiPoint } from '../../resource/plugins/biPoint/index';
import App from '../../App.vue';
import router from '../rooters/twStore';
import store from '../stores/twStore';
import setCommonPlugins from '../../resource/configs/setGlobalCommonPlugins';

import touchActive from '../../resource/diractives/touchActive';
import { handleStoreDefaultCid } from '@utiles/storeHandleCid';
import '@plugins/replaceAllPolyfills';
handleStoreDefaultCid();
initBiPoint({ dataLayerName: 'webstorev0DataLayer' });

Vue.directive('touchActive', touchActive);

Vue.config.productionTip = false;
setCommonPlugins(Vue);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#twStore');
